import axios from 'axios'
var apidir = 'registration/agent/'
var apidev = 'http://APIHSVR.HWGDBS:46000/onboarding/';
var apiuat = 'http://APIUATSVR.HWGDBS:46000/onboarding/';
var apiconnect = 'https://connectapi.nadia.com.my/onboarding/';
var apipath = apiconnect + apidir;
var tokenkey = 'pvtax9abe66gr78qx6eyt7wt';

const getDefaultState = () => {
    return {
        EmploymentStatus:'',
        EmploymentStatusOther : '',
        BusinessNature2:'',
        Designation: '',
        EmployerName: '',
        EmployerAddress : {
            Address1 : '',
           // Address2 : '',
            // Address3 : '',
            // Postcode : '',
            // City : '',
            // Country : '',
            // State : '',
            // StateForeign : ''
        },
        BusinessNature : '',
        BusinessNatureOther : '',
        BusinessCardAttachment: '',
        Progress: 0
    }
}

const state = getDefaultState()

// getters
const getters = {
    Empdone: state => {
        var countdone = 0;
        if(state.EmploymentStatus!=='')
            countdone = countdone + 1;

        var percentdone = countdone/0.01
        return percentdone     
    }
}

// actions
const actions = {
    SetEmployerAddressByPostcode({commit, state, rootState},postcode){
        for(var i=0; i< rootState.Lookup.Postcode_LK.length;i++){
            if(rootState.Lookup.Postcode_LK[i].Postcode===postcode){
                state.EmployerAddress.City = rootState.Lookup.Postcode_LK[i].City;
                state.EmployerAddress.Country = rootState.Lookup.Postcode_LK[i].Country;
                state.EmployerAddress.State = rootState.Lookup.Postcode_LK[i].State;
            }
        }
    }
}

// mutations
const mutations = {
    ResetState_ED (state) {
        Object.assign(state, getDefaultState())
    },
    SET_ProgressED(state){
        var countdone = 0;
        var counttotal = 0;

        if(state.EmploymentStatus==='1'){
            counttotal = 0.02;
        }
        else
        if(state.EmploymentStatus==='2'){
            counttotal = 0.09;
        }
        else{
            counttotal = 0.01;    
        }

        if(state.EmploymentStatus!==''){
            countdone = countdone + 1;
        }
            
        if(((state.EmploymentStatus==='1'||state.EmploymentStatus==='2') && state.BusinessNature!=='')){
            if((state.BusinessNature==='A18' && state.BusinessNatureOther!=='') || state.BusinessNature!=='A18'){
                countdone = countdone + 1;
            }   
        }

        if(state.EmploymentStatus==='2' && state.Designation!==''){
            countdone = countdone + 1;
        }

        if(state.EmploymentStatus==='2' && state.EmployerName!==''){
            countdone = countdone + 1;
        }

        
        if(state.EmploymentStatus==='2' && state.EmployerAddress.Address1!==''){
            countdone = countdone + 1;
        }

        if(state.EmploymentStatus==='2' && state.EmployerAddress.Postcode!==''){
            countdone = countdone + 1;
        }

        if(state.EmploymentStatus==='2' && state.EmployerAddress.City!==''){
            countdone = countdone + 1;
        }
        
        if(state.EmploymentStatus==='2' && state.EmployerAddress.Country!==''){
            countdone = countdone + 1;
        }

        if(state.EmploymentStatus==='2' && ((state.EmployerAddress.Country==='MY' && state.EmployerAddress.State!=='') || (state.EmployerAddress.Country!=='MY' && state.EmployerAddress.StateForeign!==''))){
            countdone = countdone + 1;
        }

        state.Progress = countdone/counttotal;
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
